import React from "react";
import "./heroPage.css";

import a4PaperImg from "../assets/a4paper.png";
import registerImg from "../assets/register.png";
import rubberStampsImg from "../assets/rubber_stamps.png";
import allTypesImg from "../assets/all_types.png";
import panchayathImg from "../assets/panchayath.png";
import stationeryImg from "../assets/stationery.png";
import filesImg from "../assets/files.png";
import rightSectionImg from "../assets/right section.png";

const HeroPage = () => {
  return (
    <section className="hero-section">
      {/* Top text area */}
      <div className="hero-inner">
        <h1 className="hero-title">
          Everything you need - fresh,
          <br />
          affordable, and{" "}
          <span className="highlight-text">at your doorstep.</span>
        </h1>

        <p className="hero-subtitle">
          MRF.&amp; Suppliers of Ledger books, Demand books, Office files and
          Stationary items.
        </p>

        <div className="hero-contact-row">
          <div className="contact-pill">shubhagraphickskkl@gmail.com</div>
          <div className="contact-pill">Office : 9449645510</div>
        </div>
      </div>

      {/* Bottom visual area */}
      <div className="hero-bottom">
        {/* Left scattered cards */}
        <div className="hero-left">
          <div className="cards-layer">
            {/* Row 1 */}
            <div className="product-card card-register">
              <img
                src={registerImg}
                alt="Register Books"
                className="product-image"
              />
              <span className="product-name">Register Books</span>
            </div>

            <div className="product-card card-a4">
              <img
                src={a4PaperImg}
                alt="A4 Papers"
                className="product-image"
              />
              <span className="product-name">A4 Papers</span>
            </div>

            <div className="product-card card-panchayat">
              <img
                src={panchayathImg}
                alt="Panchayat Books"
                className="product-image"
              />
              <span className="product-name">Panchayat Books</span>
            </div>

            {/* Row 2 */}
            <div className="product-card card-files">
              <img src={filesImg} alt="Files" className="product-image" />
              <span className="product-name">Files</span>
            </div>

            <div className="product-card card-office">
              <img
                src={stationeryImg}
                alt="Office stationery"
                className="product-image"
              />
              <span className="product-name">Office stationery</span>
            </div>

            {/* Row 3 */}
            <div className="product-card card-rubber">
              <img
                src={rubberStampsImg}
                alt="Rubber Stamps"
                className="product-image"
              />
              <span className="product-name">Rubber Stamps</span>
            </div>

            <div className="product-card card-alltypes">
              <img
                src={allTypesImg}
                alt="All Types Of Files"
                className="product-image"
              />
              <span className="product-name">All Types Of Files</span>
            </div>
          </div>
        </div>

        {/* Right cropped image */}
        <div className="hero-right">
          <img
            src={rightSectionImg}
            alt="Office stationery collection"
            className="hero-right-image"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroPage;